const config = {
    BASE_URL: "https://api.pax.technology", // Change this to your backend API URL
  };
  
  export default config;
  
